import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero'; 
import Homebody1 from '../components/homepage/homepagebody1';
import Homebody2 from '../components/homepage/homepagebody2';
import Homebody3 from '../components/homepage/homepagebody3';
import Homebody4 from '../components/homepage/homepagebody4';
import Footer from '../components/Footer';
import Loader from '../components/Loader'; // Import Loader component

const Homepage = () => {
  const [isLoading, setIsLoading] = useState(true); // Added loading state

  // Simulate page loading time (e.g., 2 seconds)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after 2 seconds
    }, 2000);

    return () => clearTimeout(timer); // Cleanup timeout on component unmount
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />  
      ) : (
        <div
          style={{
            background: 'linear-gradient(135deg, rgb(247, 248, 249) 50%, #29313F 50%)',
          }}
        >
          <Header />
          <Hero />      
          <Homebody2 />
          <Homebody1 />
          <Homebody3 />
          <Homebody4 />
          <Footer />
        </div>
      )}
    </>
  );
};

export default Homepage;
